type TShowOn = 'dirty' | 'touched';

export class MessagesConfiguration {
  showOn: TShowOn[] = ['touched'];
}
